import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { ServiceTemplate } from '../types/entities';

interface ServiceTemplateDeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  serviceTemplate: ServiceTemplate | null;
}

const ServiceTemplateDeleteConfirmationDialog: React.FC<ServiceTemplateDeleteConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  serviceTemplate,
}) => {
  const { t } = useTranslation();
  if (!serviceTemplate) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{t('dialogs.confirmDeleteServiceTemplate')}</Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          {t('dialogs.deleteServiceTemplateConfirmation', { serviceTemplateName: serviceTemplate.name })}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('dialogs.deleteServiceTemplateWarning')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} color="error" variant="contained">
          {t('common.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceTemplateDeleteConfirmationDialog;

